module.exports = __webpack_public_path__ + "b6d7511d57e9acd53c7c7d81043e05b9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cauldron-s.png
// module id = 1251
// module chunks = 0